import { TRANSLATION_DEFAULTS } from '../communityPostComposer/_components/constants';
import { createTranslate } from './createTranslate';

// Translates the keys of the community components (composer, schedule picker, announcement confirmation) into English
// from TRANSLATION_DEFAULTS, for a host without i18next, like the dashboard. Orchid passes its own `t` instead.
export const defaultCommunityTranslate = createTranslate(TRANSLATION_DEFAULTS);
